import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Projects.scss';
import Axios from 'axios';
import { Error } from '../../components/Error/Error.jsx';
import { Loader } from '../../components/Loader/Loader.jsx';
import { API_URL } from '../../config';

export const Projects = () => {
	const [projects, setProjects] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [projectTitle, setProjectTitle] = useState('');

	// Obtener los proyectos ya ordenados por el backend
	const getProjects = async () => {
		setLoading(true);
		try {
			const { data: response } = await Axios.get(`${API_URL}/projects`);
			setProjects(response.data);
		} catch (error) {
			console.error(error);
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getProjects();
	}, []);

	// Mostrar título al hacer hover
	const handleHover = (e) => {
		const title = e.target.getAttribute('project_title');
		setProjectTitle(title);
	};

	const handleMouseOut = () => {
		setProjectTitle('');
	};

	return (
		<div className='Projects'>
			{loading && <Loader />}
			{error && <Error error={error} />}

			<div className='projects-img-container'>
				{projects.map((project) => (
					<Link
						to={`/${project._id}`}
						key={project._id}
						project_title={project.title}
					>
						<img
							src={project.cover?.secure_url}
							alt={project.name}
							id={project._id}
							project_title={project.title}
							onMouseOver={handleHover}
							onMouseOut={handleMouseOut}
						/>
						<p>{project.title}</p>
					</Link>
				))}
			</div>

			<div className='projects-text-container'>
				<p>{projectTitle}</p>
			</div>
		</div>
	);
};
